import { createSnackbarNotification } from "@frontiers/brink-ui";
import ErrorMessages from "~/helpers/ErrorMessages";
import type { ThirdPartyRegisterStep0 } from "~/models/ThirdPartyRegisterStep0";
import type { ThirdPartyLogin } from "~/models/ThirdPartyLogin";

export class ThirdPartyService {
    public static async thirdPartyRegister(
        regiterStep0: ThirdPartyRegisterStep0,
        setLoading: (isLoading: boolean) => void
    ): Promise<boolean> {
        setLoading(true);
        try {
            const response = await fetch("/api/onboarding-ui/v1/thirdparty/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(regiterStep0)
            });

            if (response.ok) {
                const thirdPartyUrl = await response.json();
                navigateTo(thirdPartyUrl, { external: true });
                setTimeout(() => {
                    setLoading(false);
                }, 3000);
            } else {
                const errorResult = await response.json();
                const errorCode = errorResult.Code;
                const errorMessage = ErrorMessages.getMessage(errorCode);
                createSnackbarNotification({
                    message: errorMessage,
                    type: "error",
                    autoDismiss: true,
                    showCloseIcon: true
                });
            }
        } catch (e) {
            console.error("Error on third party register: " + e);
            throw e;
        } finally {
            setLoading(false);
        }
    }

    public static async thirdPartyLogin(
        login: ThirdPartyLogin,
        setLoading: (isLoading: boolean) => void
    ): Promise<boolean> {
        setLoading(true);
        try {
            const response = await fetch("/api/onboarding-ui/v1/thirdparty/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(login)
            });

            if (response.ok) {
                const thirdPartyUrl = await response.json();
                navigateTo(thirdPartyUrl, { external: true });
                setTimeout(() => {
                    setLoading(false);
                }, 3000);
            } else {
                const errorResult = await response.json();
                const errorCode = errorResult.Code;
                const errorMessage = ErrorMessages.getMessage(errorCode);
                createSnackbarNotification({
                    message: errorMessage,
                    type: "error",
                    autoDismiss: true,
                    showCloseIcon: true
                });
            }
        } catch (e) {
            console.error("Error on third party login: " + e);
            throw e;
        } finally {
            setLoading(false);
        }
    }
}

